import gql from 'graphql-tag'

const query = gql`
query listHistory(
	$params: ListQueryArgs,
	$type: HistoryTypes!,
	$language: Language
	$recordId: ID
){
	cashAssist {
		listHistory(params: $params, type: $type, recordId: $recordId) {
			items {
				id
				recordId
				timestamp
				oldValue
				newValue
				fieldName
				userName
				content
				dbFieldName
				dbFieldType
				newValueID
				formName(language: $language)
				operation(language: $language)
			}
			cursors {
				hasNext
				hasPrevious
				before
				after
			}
			hasNextPage
			total
		}
  	}
}
`

export default query
